var CubeTextureSoftware = (function () {
    function CubeTextureSoftware(size) {
        this._textureSelectorDictionary = [[], [], [], [], [], []];
        this._size = size;
    }
    Object.defineProperty(CubeTextureSoftware.prototype, "textureType", {
        get: function () {
            return CubeTextureSoftware.textureType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CubeTextureSoftware.prototype, "size", {
        get: function () {
            return this._size;
        },
        enumerable: true,
        configurable: true
    });
    CubeTextureSoftware.prototype.dispose = function () {
        this._textureSelectorDictionary = null;
    };
    CubeTextureSoftware.prototype.isTexture = function (textureClass) {
        return this.textureType == textureClass.textureType;
    };
    CubeTextureSoftware.prototype.uploadFromImage = function (imageCube, side, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        this._textureSelectorDictionary[side][miplevel] = imageCube.getImageData(side).data;
    };
    CubeTextureSoftware.prototype.getData = function (side, miplevel) {
        if (miplevel === void 0) { miplevel = 0; }
        return this._textureSelectorDictionary[side][miplevel];
    };
    CubeTextureSoftware.prototype.getMipLevelsCount = function () {
        return 1;
    };
    CubeTextureSoftware.prototype.generateMipmaps = function () {
        //TODO
    };
    CubeTextureSoftware.prototype.uploadCompressedTextureFromByteArray = function (data, byteArrayOffset, async) {
        // TODO
    };
    return CubeTextureSoftware;
}());
export { CubeTextureSoftware };
CubeTextureSoftware.textureType = "textureCube";



// WEBPACK FOOTER //
// ../dist/lib/software/CubeTextureSoftware.js